module.exports = __webpack_public_path__ + "img/page_title_1.2fd49e0d.png";